const agentA = navigator.userAgent.replace(')', 'strict').search('strict');
const agentB = navigator.userAgent.slice(0, agentA);
const agentC = agentB.slice(agentB.search(';') + 1);

export const deviceName = agentC.slice(agentC.search(';') + 1);
export const appUpdateVersion = '@1.9.0';
export const appName = 'myKanisa App';

export const defaultSettings = {
    themeMode: 'light', // light . dark
    layout: 'normal', // normal . spaced
};
